export default __webpack_public_path__ + "static/media/avatar_tapir6.90c589b8.mp3";